<div class="auth-container">
<div class="container">
    <div class="row">
        <div class="login-container col-lg-6 col-sm-12 text-center offset-lg-3">
            <div class="login-box text-center">
                <div class="title">Update Phone Number</div>
                <div class="sub-title">It looks like you requested a phone number update.</div>

                <form
                    class="form text-start form-wrapper"
                    [formGroup]="setPhoneForm"
                    (ngSubmit)="onSubmit()"
                    autocomplete="off"
                >
                    <div class="form-group mt-4 mb-3">
                        <label class="control-label mb-2" for="set-phone-old-phone-input">Old Phone Number*</label>
                        <input
                            id="set-phone-old-phone-input"
                            type="text"
                            class="form-control"
                            formControlName="oldPhone"
                            phoneMask
                            [preValue]="setPhoneForm.value.oldPhone"
                            [phoneControl]="setPhoneForm.controls['oldPhone']"
                            maxlength="14"
                        />
                        <p
                            class="error-msg"
                            id="set-phone-old-phone-error-message"
                            *ngIf="(form['oldPhone'].errors?.['required'] || form['oldPhone'].errors?.['pattern']) && (form['oldPhone'].dirty || form['oldPhone'].touched || submitted)"
                        >
                            Field should be a valid 10 digit phone number.
                        </p>
                    </div>

                    <div class="form-group mt-3">
                        <label class="control-label mb-2" for="set-phone-new-phone-input">New Phone Number*</label>
                        <input
                            id="set-phone-new-phone-input"
                            type="text"
                            class="form-control"
                            formControlName="newPhone"
                            phoneMask
                            [preValue]="setPhoneForm.value.newPhone"
                            [phoneControl]="setPhoneForm.controls['newPhone']"
                            maxlength="14"
                        />
                        <p
                            class="error-msg"
                            id="set-phone-new-phone-error-message"
                            *ngIf="(form['newPhone'].errors?.['required'] || form['newPhone'].errors?.['pattern']) && (form['newPhone'].dirty || form['newPhone'].touched || submitted)"
                        >
                            Field should be a valid 10 digit phone number.
                        </p>
                        <p
                            class="error-msg"
                            id="set-phone-new-phone-same-error-message"
                            *ngIf="setPhoneForm.errors?.['newPhoneSameAsOld'] && (form['newPhone'].dirty || form['newPhone'].touched || submitted)"
                        >
                            New phone number must be different from old phone number.
                        </p>
                    </div>

                    <div class="form-group mt-3">
                        <label class="control-label mb-2" for="set-phone-confirm-phone-input">Confirm Phone Number*</label>
                        <input
                            id="set-phone-confirm-phone-input"
                            type="text"
                            class="form-control"
                            formControlName="confirmPhone"
                            phoneMask
                            [preValue]="setPhoneForm.value.confirmPhone"
                            [phoneControl]="setPhoneForm.controls['confirmPhone']"
                            maxlength="14"
                        />
                        <p
                            class="error-msg"
                            id="set-phone-confirm-phone-error-message"
                            *ngIf="(form['confirmPhone'].errors?.['required'] || form['confirmPhone'].errors?.['pattern']) && (form['confirmPhone'].dirty || form['confirmPhone'].touched || submitted)"
                        >
                            Field should be a valid 10 digit phone number.
                        </p>
                        <p
                            class="error-msg"
                            id="set-phone-confirm-phone-mismatch-error-message"
                            *ngIf="setPhoneForm.errors?.['confirmPhoneMismatch'] && (form['confirmPhone'].dirty || form['confirmPhone'].touched || submitted)"
                        >
                            Confirmation phone number does not match the new phone number.
                        </p>
                    </div>

                    <div class="text-center">
                        <button
                            id="set-phone-submit-button"
                            class="btn btn-normal btn-pink btn-pink-filled mt-4"
                            type="submit"
                            [disabled]="isSubmitting"
                        >
                            {{ isSubmitting ? 'Updating...' : 'Update Phone Number' }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</div>
